module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"go":"去支付","tip":"请输入支付密码"},"TW":{"go":"去支付","tip":"請輸入支付密碼"},"en":{"go":"Pay","tip":"Please enter payment password"}}')
  delete Component.options._Ctor
}
